import styled from "@emotion/styled";
import Modal from "../../../../UI/Modal/Modal";
import { scrollbarDe } from "../../../../styles/styledSnippets";
import Checkbox from "../../../../UI/Form/Checkbox/Checkbox";
import { useEffect, useState } from "react";
import {
  isFilterCheckedForCurrentTab,
  toggleFilterForCurrentTab,
} from "./helper";
import ButtonGroup from "../../../../UI/ButtonGroup/ButtonGroup";
import IOButton from "../../../../UI/Form/Button/IOButton";

const Container = styled.div(
  ({ theme }) => `
  height: 50vh;
  overflow-y: auto;
  ${scrollbarDe(theme)};
`
);

export default function AddFiltersToPageModal(props) {
  const { onClose, siteConfig, activeTab, onSave } = props;

  const [filters, setFilters] = useState([]);

  useEffect(() => {
    if (siteConfig.menuFilters.list.length && !filters.length) {
      setFilters(siteConfig.menuFilters.list);
    }
  }, [siteConfig.menuFilters.list, filters.length]);

  function handleFilterToggle(uuid) {
    const updatedFilters = filters.map((filter) =>
      filter.uuid === uuid
        ? toggleFilterForCurrentTab(filter, activeTab.uuid)
        : filter
    );
    setFilters(updatedFilters);
  }

  return (
    <Modal renderInPortal close={onClose} title="Filters">
      <Container>
        {filters.map((filter) => (
          <Checkbox
            key={filter.uuid}
            label={filter.displayName}
            checked={isFilterCheckedForCurrentTab(filter, activeTab.uuid)}
            onChange={() => handleFilterToggle(filter.uuid)}
          />
        ))}
      </Container>
      <br />

      <ButtonGroup position="center" spacing={15}>
        <IOButton onClick={onClose} cancel>
          Cancel
        </IOButton>
        <IOButton
          type="button"
          onClick={() => onSave(filters)}
          processing={siteConfig.processing}
        >
          Save
        </IOButton>
      </ButtonGroup>
    </Modal>
  );
}
